import type {
  AIResponse,
  VehicleInfo,
  AIDiagnosisCause,
  AIFixSteps,
  ChatSession,
} from "../types";

// Import all services
import * as ollamaService from "./ollamaService";
import * as geminiService from "./geminiService";
import * as privateLLMService from "./privateLLMService";
import * as openaiService from "./openaiService";
import * as ragService from "./ragService";

// Define the AI service interface
export interface AIService {
  analyzePartImagesForFault: (
    fileContent: string,
    mimeType: string,
  ) => Promise<string>;
  startChatSession: (
    vehicleInfo: VehicleInfo,
  ) => Promise<{ chat: ChatSession; response: AIResponse }>;
  continueChatSession: (
    chat: ChatSession,
    message: string,
  ) => Promise<AIResponse>;
  getFixSteps: (
    vehicleInfo: VehicleInfo,
    cause: AIDiagnosisCause,
  ) => Promise<AIFixSteps>;
  getCauseDetails: (
    vehicleInfo: VehicleInfo,
    cause: AIDiagnosisCause,
  ) => Promise<string>;
  lookupDtcCode: (code: string) => Promise<string>;
}

// Removed unused getEnvironment function

// Get the AI service based on environment or user selection
export const getAIService = (): AIService => {
  // Check localStorage first (for toggle), then fall back to env variable
  const localStorageMode = localStorage.getItem("aiMode");
  const serviceOverride = localStorageMode || process.env.REACT_APP_AI_SERVICE;

  if (serviceOverride === "gemini") {
    return geminiService as AIService;
  } else if (serviceOverride === "ollama") {
    return ollamaService as AIService;
  } else if (serviceOverride === "private") {
    return privateLLMService as AIService;
  } else if (serviceOverride === "openai") {
    return openaiService as AIService;
  } else if (serviceOverride === "rag") {
    return ragService as AIService;
  }

  // Default behavior: Private LLM for both production and development
  return privateLLMService as AIService;
};

// Export the current service instance
export const aiService = getAIService();

// Re-export all the service functions for convenience
export const {
  analyzePartImagesForFault,
  startChatSession,
  continueChatSession,
  getFixSteps,
  getCauseDetails,
  lookupDtcCode,
} = aiService;
